// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__3EIJF","consentsList":"PatientConsents_consentsList__1NlRC","consentsListEmpty":"PatientConsents_consentsListEmpty__2OTB0"};